module.exports = __webpack_public_path__ + "static/img/mine_bg.ee3bff95.png";